<template>
  <div class="component-email" style="margin-bottom: 50px;">
    <div v-if="!mailSent">
      <div class="email-text">
        <h2>Skicka resultatet</h2>
        <p>Vill du spara ditt resultat för din egna utvecklings skull? Fyll i din email nedan så skickar vi sammanställningen direkt till din inkorg!</p>
        <form>
          <div class="form-group">
            <input
              @blur="emailHasFocus = false"
              @focus="emailHasFocus = true"
              :class="{'text-danger':showEmailError()}"
              v-model="emailInput"
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              placeholder="Email-adress"
            >
          </div>
          <p v-if="sendError == true" class="text-danger">Det gick inte att skicka meddelandet. Testa igen om en liten stund!</p>
          <button :disabled="!validEmail() || !canSend" type="submit" @click.prevent="sendEmail()" class="send-button float-right">Skicka</button>
        </form>
      </div>
    </div>
    <div v-if="mailSent">
      <div class="email-text">
        <h2>Ditt resultat är sparat!</h2>
        <p>Ditt resultat från SOIs Kompetenskollen är sparat! Du kan nå ditt resultat direkt på länken nedan.</p>
        <p>Det är bara du och de personerna som du väljer att dela länken med som kan se ditt resultat.</p>
        <div class="form-group">
          <input type="text" :value="url + resultId" class="form-control" id="copy-input" />
        </div>
        <button @click.prevent="copy()" class="copy-button float-right">Kopiera</button>
        <div style="clear: both;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created () {},
  data () {
    return {
      emailHasFocus: false,
      canSend: true,
      sendError: false,
      emailInput: "",
      mailSent: false,
      url: "https://www.soi-kompetenskollen.se/result/"
    };
  },
  props: ["resultId", "apiUrl"],
  methods: {
    copy () {
      var copyElm = document.querySelector("#copy-input");

      var editable = copyElm.contentEditable;
      var readOnly = copyElm.readOnly;

      if (navigator.userAgent.match(/ipad|iphone/i)) {
        copyElm.contentEditable = true;
        copyElm.readOnly = false;
        var range = document.createRange();
        range.selectNodeContents(copyElm);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        copyElm.setSelectionRange(0, 999999);
      } else {
        copyElm.contentEditable = true;
        copyElm.readOnly = false;
        copyElm.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
      }
      copyElm.contentEditable = editable;
      copyElm.readOnly = readOnly;
    },
    validEmail () {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.emailInput.toLowerCase());
    },
    sendEmail () {
      if (!this.validEmail()) {
        return;
      }
      var self = this;
      self.sendError = false;
      this.canSend = false;

      axios(this.apiUrl + "SendResult/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify({ email: this.emailInput, guid: this.resultId })
      }).then(result => {
        if (result.status === 200) {
          self.emailInput = "";
          self.mailSent = true;
        } else {
          self.sendError = true;
        }
        setTimeout(() => {
          self.canSend = true;
        }, 2000);
      })
        .catch(function () {
          self.sendError = true;
          setTimeout(() => {
            self.canSend = true;
          }, 2000);
        });
    },
    showEmailError() {
      return !this.emailHasFocus && !this.validEmail() && this.emailInput.length > 0;
    }
  },
};
</script>

<style scoped lang="scss">
.email-text {
  margin: 0px 25px 25px 25px;
  h2 {
    font-family: "museo-slab";
    font-size: 30px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #2c302e;
    text-align: center;
    margin-bottom: 10px;
    margin-top: 38px;
    text-transform: uppercase;
  }
  p {
    font-family: "museo-sans";
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #2c302e;
  }
  @media (max-width: 991px) {
    h2 {
      font-family: "museo-slab";
      font-size: 24px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #2c302e;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 38px;
      text-transform: uppercase;
    }
    p {
      font-family: "museo-sans";
      font-size: 16px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #2c302e;
    }
  }
}
.form-control {
  background-color: #e1dacf;
  border: none;
  border-radius: 0;
  font-family: "museo-sans";
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #2c302e;
}
.url-link {
  padding: 10px;
}

button.send-button,
button.copy-button {
  font-family: "museo-sans";
  padding-left: 30px;
  padding-right: 30px;
  background-color: #22547f;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.2px;
  text-align: center;
  color: #ffffff;
  outline: none;
  border: none;
}

button.send-button:disabled {
  cursor: pointer;
  background-color: #6e89a1;
}

input.text-danger {
  color: #dc3545 !important;
  transition: color 0.5s;
}
</style>
